(function () {
    'use strict';

    /**
     * @module providerResults
     * Handles sort comparators and wires up QLD.ListPagination for the provider results list.
     * Requires _pagination.js to be loaded first.
     */
    const providerResults = {};

    providerResults.init = function () {
        const resultsWrapper = document.querySelector('[data-role~="maps-search-results"]');
        const results = document.querySelector('[data-role~="provider-results"]');
        const sortSelect = document.querySelector('[data-role~="maps-results-sort"]');
        const summaryRange = document.querySelector('[data-role~="maps-search-summary-range"]');
        const summaryTotal = document.querySelector('[data-role~="maps-search-summary-total"]');

        if (!results || !resultsWrapper) return;

        if (resultsWrapper.dataset.providerResultsInitialised === 'true') return;
        resultsWrapper.dataset.providerResultsInitialised = 'true';

        const comparators = {
            dname: (a, b) => (b.dataset.name || '').localeCompare(a.dataset.name || ''),
            funded: (a, b) => {
                const diff = Number(b.dataset.fundingPriority || 0) - Number(a.dataset.fundingPriority || 0);
                return diff || Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
            },
            name: (a, b) => (a.dataset.name || '').localeCompare(b.dataset.name || ''),
        };

        const pagination = new QLD.ListPagination(results, {
            wrapper: resultsWrapper,
            pageSize: 6,
            pageSizeOptions: [6, 12, 24, 48, 99, -1]
        });

        function updateSummary({ visibleStart, visibleEnd, totalItems }) {
            if (summaryRange) {
                summaryRange.textContent = totalItems ? `${visibleStart}–${visibleEnd} of` : '';
            }
            if (summaryTotal) {
                summaryTotal.textContent = `${totalItems} providers`;
            }
        }

        results.addEventListener('pagination:change', ({ detail }) => updateSummary(detail));
        
        function sortCards(method) {
            const comparator = comparators[method] || comparators.name;
            const cards = [...results.children];
            cards.sort(comparator);
            const fragment = document.createDocumentFragment();
            cards.forEach(card => fragment.appendChild(card));
            results.appendChild(fragment);
        }

        sortCards(sortSelect ? sortSelect.value : 'funded');
        pagination.init();

        const providerListFilter = new QLD.ListFilter({
            element: results,
            controlsContainer: results.closest('#course__training-providers'),
            urlIsUpdatable: false,
            filtersCallback: (matchedItems) => pagination.refresh(matchedItems),
            hiddenClass: 'hidden'
        });


        if (sortSelect) {
            sortSelect.addEventListener('change', function () {
                sortCards(this.value);
                providerListFilter.applyFilters(results);
            });
        }
    };

    window.QLD = window.QLD || {};
    QLD.providerResults = providerResults;

    document.addEventListener('DOMContentLoaded', () => {
        QLD.providerResults.init();
    });
}());
